/**
 * @author kuan
 */

import { mapGetters } from 'vuex'
import toAnalysisParams from '@/plugins/toAnalysisParams';

export const ANALYSIS = {
  setting: {category:'', action:'none', label:''},
  swap: {category:'material_setting_checkbox', action:'click_swap', label:'素材设置_选中框_替换'},
  flip: {category:'material_setting_checkbox', action:'click_flip_horizontal', label:'素材设置_选中框_水平翻转'},
  motion: {category:'material_setting_checkbox', action:'click_action', label:'素材设置_选中框_动作'},
  delete: {category:'material_setting_checkbox', action:'click_delete', label:'素材设置_选中框_删除'},
  deleteAll: {category:'materCombination_quick_setting_panel', action:'click_delete', label:'素材组合_快捷面板_删除'},
  edit: {category:'material_setting_checkbox', action:'click_data_edit', label:'素材设置_选中框_编辑数据'},
  switch: {category:'material_setting_checkbox', action:'click_chart_type', label:'素材设置_选中框_切换图表'},
  color: {category:'material_setting_checkbox', action:'click_color', label:'素材设置_选中框_颜色'},
  next: {category:'material_setting_checkbox', action:'click_textsize', label:'素材设置_选中框_文字大小'},
  'stroke-width': {category:'material_setting_checkbox', action:'click_stroke_width', label:'素材设置_选中框_线条大小'},
  'lock': {category:'quick_setting_panel', action:'click_locking', label:'快捷设置面板_锁定'},

  'cut-video': toAnalysisParams('quick_setting_panel,click_video_clipping,快捷设置面板_裁剪'),
  'set-muted': toAnalysisParams('quick_setting_panel,click_video_set_mute,快捷设置面板_设置静音'),
  'cancel-muted': toAnalysisParams('quick_setting_panel,click_video_cancel_mute,快捷设置面板_取消静音'),

  animationSetting : {category:'materCombination_quick_setting_panel', action:'click_enter_exit_animation', label:'素材组合_快捷面板_出入场动画'},
  layerSetting : {category:'materCombination_quick_setting_panel', action:'click_layer', label:'素材组合_快捷面板_图层'},
  spritesAlign  : {category:'materCombination_quick_setting_panel', action:'click_align', label:'素材组合_快捷面板_对齐'},
  effect: toAnalysisParams('quick_setting_panel,click_animation_setting,快捷设置面板_动画设置'),
  drawingDuration: toAnalysisParams('quick_setting_panel,click_animation_handPainting_time,快捷设置面板_手绘时间设置'),
};

/**
 *
 * @param {String | Number} name 编辑器的当前主题
 * @param {String} place 点击是来自哪里的
 *     'material_setting_panel' 素材设置弹窗 | 'material_setting_panel_2' 图表类型设置弹窗
 */
function byTheme(name = 78, place = 'material_setting_panel', nameMap = {}) {
  // let nameMap = {
  //   '78': ['commercial', '商务'],
  //   '79': ['lovely', '可爱'],
  //   '80': ['simple', '简约'],
  //   '81': ['handpainted', '手绘']
  // };

  let target = nameMap['' + name];

  if (!target) {
    return {}
  }

  return {
    pie: {category: place, action:`click_add_pie_${target[0]}`, label:`素材设置_设置面板_形状_图表_饼图_${target[1]}`},
    line: {category: place, action:`click_add_line_${target[0]}`, label:`素材设置_设置面板_形状_图表_折线图_${target[1]}`},
    bar: {category: place, action:`click_add_bar_${target[0]}`, label:`素材设置_设置面板_形状_图表_柱状图_${target[1]}`}
  }
}

export default {
  data () {
    return {
      ANALYSIS
    }
  },
  computed: {
    ...mapGetters([
      'StyleMsg',
      'StyleArrayMsg'
    ]),
    nameMap () {
      let ret = {};
      this.StyleArrayMsg.forEach(item => {
        ret['' + item.id] = [item.id, item.name];
      });
      return ret;
    }
  },
  watch: {
    StyleMsg (val) {
      let params = this.byTheme(val);
      this.ANALYSIS = { ...this.ANALYSIS, types: params, types2: this.byTheme(val, 'material_setting_panel_2') };
    }
  },
  created () {
    let params = this.byTheme(this.StyleMsg);
    this.ANALYSIS = { ...this.ANALYSIS, types: params, types2: this.byTheme(this.StyleMsg, 'material_setting_panel_2') };
  },
  methods: {
    /**
     *
     * @param {String} chartType 'pie' | 'line' | 'bar'
     */
    reportAnalysis (chartType) {
      let param = this.ANALYSIS.types[chartType];
      param && this.$analysis(param);
    },

    reportAnalysis2 (chartType) {
      let param = this.ANALYSIS.types2[chartType];
      param && this.$analysis(param);
    },

    reportByCase (type, chartFrom) {
      let typeMap = {
        'PieChart': 'pie',
        'BarChart': 'bar',
        'LineChart': 'line'
      };

      let replaceMap = {
        'chartType': 'reportAnalysis2',
        'chartSetting': 'reportAnalysis'
      };

      let funcName = replaceMap[chartFrom];
      funcName && this[funcName](typeMap[type]);
    },

    byTheme (name = 78, place = 'material_setting_panel') {
      return byTheme(name, place, this.nameMap);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/analysis/spriteBtns.js